import { budgetService } from "@/services/end-points/orcamento";
import { useQuery } from "@tanstack/react-query";

export const useFindItemsByStep = (budgetId: number, stepId: number) => {
  return useQuery({
    queryKey: ['budget-step-items', budgetId, stepId],
    queryFn: () => budgetService.findItemsByStep(budgetId, stepId),
    enabled: !!budgetId && !!stepId,
  });
}